export const BLOCKED_VALUE_MODAL_PT_BR = {
	title: "Valor Bloqueado",
	description: "O que são os valores bloqueados?",
	descriptionText: [
		"Valores bloqueados são montantes temporariamente indisponíveis",
		"devido a políticas de segurança ou processamento de transações.",
	].join(" "),
	totalSummary: "Somatória total",
	liquidationDate: "DATA DE LIQUIDAÇÃO",
	competenceDate: "DATA DE COMPETÊNCIA",
	receivableType: "TIPO DE RECEBÍVEL",
	contractEffectType: "TIPO DE EFEITO DE CONTRATO",
	observation: "OBSERVAÇÃO",
	value: "VALOR",
	receivableTypes: {
		credit: "Crédito",
		debit: "Débito",
	},
	blockCategories: {
		"Transferência de titularidade": "Transferência de titularidade",
		"Ônus - Cessão fiduciária": "Ônus - Cessão fiduciária",
		"Ônus - Outros": "Ônus - Outros",
		"Bloqueio judicial": "Bloqueio judicial",
		"Promessa de Cessão": "Promessa de Cessão",
		"Tipo desconhecido": "Tipo desconhecido",
	},
};

export type BlockedValueModalTranslations = typeof BLOCKED_VALUE_MODAL_PT_BR;
